import { render, staticRenderFns } from "./WaitReimbursementDetail.vue?vue&type=template&id=a5525f14&"
import script from "./WaitReimbursementDetail.vue?vue&type=script&lang=js&"
export * from "./WaitReimbursementDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitReimbursementDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports